import type React from 'react';
import type { PropsWithChildren } from 'react';
import { TouchableOpacity } from 'react-native';

interface PressableWrapperProps extends PropsWithChildren {
  onPress?: () => void;
}

export const PressableWrapper: React.FC<PressableWrapperProps> = ({
  children,
  onPress,
}) => {
  if (!onPress) {
    return <>{children}</>;
  }

  return <TouchableOpacity onPress={onPress}>{children}</TouchableOpacity>;
};
